export function getStatus(result) {
  const { success, fail, total } = result
  return total === success ? 'success' : total === fail ? 'fail' : 'partial'
}
